<template>
  <div class="spinner">
    <f7-icon fa="circle-o-notch" class="fa-spin"></f7-icon>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
.spinner {
  color: var(--actionButtonColor);
  font-size: 28px;
  text-align:center;
  padding: inherit;
}
</style>



// WEBPACK FOOTER //
// spinner.vue?6c691ab3